import { z } from "zod/v4";

import { AgenticLogicSdkDenialDescriptions } from "../../../descriptions/agentic-logic.describe";
import { assertDescriptions } from "../../../descriptions/types";

// ---------------------------------------------------------------------------
// Denial (Admin budget guard) — surfaces as telemetry errorClass "denied",
// NEVER as silently-empty data
// ---------------------------------------------------------------------------

export const AgenticLogicSdkDenialReasonList = [
  "admin_budget_exhausted",
  "admin_concurrency_exhausted",
  "shopifyql_unavailable",
] as const;

export const AgenticLogicSdkDenialReasonSchema = z.enum(
  AgenticLogicSdkDenialReasonList
);

export type AgenticLogicSdkDenialReason =
  (typeof AgenticLogicSdkDenialReasonList)[number];

export const AgenticLogicSdkDenialSchema = z
  .object({
    reason: AgenticLogicSdkDenialReasonSchema.describe(
      AgenticLogicSdkDenialDescriptions.reason
    ),
    resource: z.string().describe(AgenticLogicSdkDenialDescriptions.resource),
    message: z.string().describe(AgenticLogicSdkDenialDescriptions.message),
  })
  .describe(AgenticLogicSdkDenialDescriptions._schema);

export type AgenticLogicSdkDenial = z.infer<typeof AgenticLogicSdkDenialSchema>;

assertDescriptions<
  typeof AgenticLogicSdkDenialDescriptions,
  AgenticLogicSdkDenial
>();
